import { render, staticRenderFns } from "./shopInventoryRecord.vue?vue&type=template&id=702f7e20&scoped=true"
import script from "./shopInventoryRecord.vue?vue&type=script&lang=js"
export * from "./shopInventoryRecord.vue?vue&type=script&lang=js"
import style0 from "./shopInventoryRecord.vue?vue&type=style&index=0&id=702f7e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702f7e20",
  null
  
)

export default component.exports